export const COUNTRY = '/country/' as const
export const COUNTRY_ALL = `${COUNTRY}all` as const
